import React from 'react';
import IndexDataProvider from './components/indexDataProvider';
import MarkupDataProvider from './components/markupData/markupDataProvider';
import ImageMarkups from './components/markupData/leftPartWithImage/imageMarkups';
import RegionsMapper from './components/markupData/leftPartWithImage/regionsMapper';

const AppHeatmap = ({ summary, project, focus, tab }) => {
  return (
    <IndexDataProvider summary={ summary } project={ project } focus={ focus }>
      <MarkupDataProvider initTab={ tab }>
        { !tab && <RegionsMapper /> }
        <ImageMarkups />
      </MarkupDataProvider>
    </IndexDataProvider>
  );
};

export default AppHeatmap;
